export default "__VITE_PUBLIC_ASSET__a2ae5867__"